import {
  ADD_CONTACT_FAILURE,
  ADD_CONTACT_REQUESTED,
  ADD_CONTACT_SUCCESS,
} from 'actiontypes/contacts';
import ContactService from 'services/ContactService';

const service = new ContactService();

/** ----------------------------------------------------------------------------
 * ADD NEW CONTACT
 -----------------------------------------------------------------------------*/
export default function addContact(userName) {
  return (dispatch) => {
    dispatch(addContactRequested());

    return service.addContact(userName)
      .then(({ data }) => {
        if (data.isSuccess || !('isSuccess' in data)) {
          return dispatch(addContactSuccess(data));
        }
        // If the API has failed to respect REST semantics and sent back a 200 with
        // an error message, then treat the response as an error
        return Promise.reject({ response: { data: { message: data.message } } });
      })
      .catch(err => dispatch(addContactFailure(err)));
  };
}

export const addContactRequested = () => ({ type: ADD_CONTACT_REQUESTED });

export const addContactSuccess = data => ({
  type: ADD_CONTACT_SUCCESS,
  payload: { message: data.message, contact: data.contact },
});

export const addContactFailure = error => ({
  type: ADD_CONTACT_FAILURE,
  // TODO: clean this up
  payload: {
    error: true,
    status: error.response && error.response.status,
    message: error && error.response.data.message,
  },
});